import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, onReset, savedViews, onSaveView, onLoadView }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [showSaveDialog, setShowSaveDialog] = useState(false);
  const [viewName, setViewName] = useState('');

  const dateRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'This Quarter' },
    { value: 'year', label: 'This Year' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const supplierOptions = [
    { value: 'all', label: 'All Suppliers' },
    { value: 'whitehaven', label: 'Whitehaven Coal' },
    { value: 'yancoal', label: 'Yancoal Australia' },
    { value: 'glencore', label: 'Glencore Coal' },
    { value: 'peabody', label: 'Peabody Energy' }
  ];

  const buyerOptions = [
    { value: 'all', label: 'All Buyers' },
    { value: 'adani', label: 'Adani Power' },
    { value: 'ntpc', label: 'NTPC Limited' },
    { value: 'tata', label: 'Tata Power' },
    { value: 'reliance', label: 'Reliance Industries' }
  ];

  const portOptions = [
    { value: 'all', label: 'All Ports' },
    { value: 'newcastle', label: 'Port of Newcastle' },
    { value: 'gladstone', label: 'Port of Gladstone' },
    { value: 'hay-point', label: 'Hay Point' },
    { value: 'abbot-point', label: 'Abbot Point' }
  ];

  const vesselOptions = [
    { value: 'all', label: 'All Vessels' },
    { value: 'mv-ocean-star', label: 'MV Ocean Star' },
    { value: 'mv-coal-carrier', label: 'MV Coal Carrier' },
    { value: 'mv-pacific-glory', label: 'MV Pacific Glory' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: 'Active' },
    { value: 'completed', label: 'Completed' },
    { value: 'pending', label: 'Pending' },
    { value: 'delayed', label: 'Delayed' }
  ];

  const handleSaveView = () => {
    if (viewName?.trim()) {
      onSaveView(viewName, filters);
      setViewName('');
      setShowSaveDialog(false);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div 
        className="flex items-center justify-between p-4 border-b border-border cursor-pointer hover:bg-muted/50"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="font-semibold text-foreground">Filters</h3>
        </div>
        <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={20} />
      </div>
      {isExpanded && (
        <div className="p-4 space-y-4">
          <Select
            label="Date Range"
            options={dateRangeOptions}
            value={filters?.dateRange}
            onChange={(value) => onFilterChange('dateRange', value)}
          />

          <Select
            label="Supplier"
            options={supplierOptions}
            value={filters?.supplier}
            onChange={(value) => onFilterChange('supplier', value)}
            searchable
          />

          <Select
            label="Buyer"
            options={buyerOptions}
            value={filters?.buyer}
            onChange={(value) => onFilterChange('buyer', value)}
            searchable
          />

          <Select
            label="Port"
            options={portOptions}
            value={filters?.port}
            onChange={(value) => onFilterChange('port', value)}
          />

          <Select
            label="Vessel"
            options={vesselOptions}
            value={filters?.vessel}
            onChange={(value) => onFilterChange('vessel', value)}
            searchable
          />

          <Select
            label="Status"
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => onFilterChange('status', value)}
          />

          <div className="flex gap-2 pt-2">
            <Button variant="outline" onClick={onReset} className="flex-1">
              Reset
            </Button>
            <Button variant="default" onClick={() => setShowSaveDialog(true)} className="flex-1">
              Save View
            </Button>
          </div>

          {savedViews && savedViews?.length > 0 && (
            <div className="pt-4 border-t border-border">
              <h4 className="text-sm font-medium text-muted-foreground mb-2">Saved Views</h4>
              <div className="space-y-2">
                {savedViews?.map((view, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between p-2 rounded-md hover:bg-muted/50 cursor-pointer"
                    onClick={() => onLoadView(view)}
                  >
                    <span className="text-sm text-foreground">{view?.name}</span>
                    <Icon name="ChevronRight" size={16} />
                  </div>
                ))}
              </div>
            </div>
          )}

          {showSaveDialog && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
              <div className="bg-card border border-border rounded-lg p-6 w-96">
                <h3 className="text-lg font-semibold mb-4">Save Filter View</h3>
                <input
                  type="text"
                  value={viewName}
                  onChange={(e) => setViewName(e?.target?.value)}
                  placeholder="Enter view name"
                  className="w-full px-3 py-2 border border-border rounded-md mb-4"
                />
                <div className="flex gap-2">
                  <Button variant="outline" onClick={() => setShowSaveDialog(false)} className="flex-1">
                    Cancel
                  </Button>
                  <Button variant="default" onClick={handleSaveView} className="flex-1">
                    Save
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterPanel;